import React from 'react'
import { OracleThumbs } from '../OracleCommons/OracleThumbs'
import type { OracleThumbValue } from '../OracleCommons/OracleThumbs'

interface OracleChatMessagePairActionsProps {
  thumbsValue: OracleThumbValue
  onThumbsUp?: () => void
  onThumbsDown?: () => void
  className?: string
}

export const OracleChatMessagePairActions: React.FC<OracleChatMessagePairActionsProps> = ({
  thumbsValue,
  onThumbsUp,
  onThumbsDown,
  className = '',
}) => {
  const baseClass = 'oracle-chat-message-pair-actions'
  const combinedClassName = `${baseClass} ${className}`.trim()

  return (
    <div className={combinedClassName}>
      <OracleThumbs
        value={thumbsValue}
        onThumbsUp={onThumbsUp}
        onThumbsDown={onThumbsDown}
      />
    </div>
  )
}
